import React from 'react';

const CatalogoPisoCaucho = () => {
  return (
    <section>
      <div className="container">
        <div className="title-style2 text-center mb-2-2 wow fadeIn" data-wow-delay="200ms">
          <h2 className="h1">Catálogo de Piso de Caucho con Entrega Inmediata</h2>
          <p>Explora nuestras opciones de Piso de Caucho, disponibles en diferentes colores y con entrega inmediata. Ideales para áreas de juego, gimnasios, espacios deportivos y más.</p>
          <p>Elige el color que mejor se adapte a tus necesidades y transforma tus espacios con esta solución duradera, segura y ecológica. Modelos disponibles:</p>
        </div>
        <div className="row gx-5 mt-n1-9 text-center">
          <div className="col-sm-6 col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="300ms">
            <div className="team-style1">
              <div className="team-img rounded image-hover">
                <img 
                  src="/assets/img/productos/piso-caucho-reciclado/piso-caucho-catalogo-verde.jpg" 
                  alt="Piso de Caucho Verde" 
                />
              </div>
              <div className="team-text">
                <div className="info rounded">
                  <h5>Piso de Caucho Verde</h5>
                  <span>Medidas: 50x50 cm.</span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-6 col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="450ms">
            <div className="team-style1">
              <div className="team-img rounded image-hover">
                <img 
                  src="/assets/img/productos/piso-caucho-reciclado/piso-caucho-catalogo-azul.jpg" 
                  alt="Piso de Caucho Azul" 
                />
              </div>
              <div className="team-text">
                <div className="info rounded">
                  <h5>Piso de Caucho Azul</h5>
                  <span>Medidas: 50x50 cm.</span>
                </div>
              </div>
            </div>
          </div>
          
          {/* Si necesitas activar el tercer modelo, puedes descomentar este bloque */}
          {/* 
          <div className="col-sm-6 col-lg-4 mt-1-9 wow fadeInUp" data-wow-delay="600ms">
            <div className="team-style1">
              <div className="team-img rounded image-hover">
                <img 
                  src="/assets/img/piso-vinilico-modelo-otro.jpg" 
                  alt="piso vinilico otro modelo" 
                />
              </div>
              <div className="team-text">
                <div className="info rounded">
                  <h5>Otro modelo</h5>
                  <span>Modelos: otro</span>
                </div>
              </div>
            </div>
          </div>
          */}
        </div>
      </div>
      <div className="circle-md right-10 top-35 border-secondary-color d-none d-lg-block"></div>
    </section>
  );
};

export default CatalogoPisoCaucho;